import React, {useState} from 'react';
import * as S from './PrivacyPolicy.stylesGcc';

const PrivacyPolicyGccArabicContent = () => {
  return (
    <>
      <S.PrivacyContent>
        <h3>القابلية:</h3>
        <p>
          تشكل هذه الاتفاقية بالإضافة إلى شروط الخدمة ("شروط الاستخدام"، إجماليا) الأحكام والشروط
          الخاصة للاستفادة من خدمات ومنتجات ("خدمات") ميكمايتريب ذ.م.م ("أم أم تي"). أي شخص
          ("المستخدم") يبرم اتفاقية شراكة السفر ويشتري أو يستفسر عن منتجات أو خدمات ميكمايتريب خلال
          موقعها الويب أي https://mypartner.makemytrip.com/ والتطبيقات للهواتف (ويشار إليها في هذه
          الوثيقة بصورة جماعية بعبارة "المواقع الإلكترونية")، يوافق على أن يخضع لشروط الاستخدام هذه.
          كما يقر المستخدم ويوافق على أن المنصة منصة تجارية للأعمال (B2B) وتوفر الخدمات للكيانات
          التجارية فقط. يشار إلى المستخدم وشركة ميكمايتريب بشكل منفرد كـ"طرف" وبشكل جماعي كـ"أطراف"
          في شروط الاستخدام. تحدد "شروط الخدمة" المتوفرة في موقع ميكمايتريب، الشروط والأحكام
          المنطبقة على الخدمات والمنتجات المتوفرة لدى ميكمايتريب. وعلى المستخدم الرجوع إلى شروط
          الخدمة المنطبقة والمعنية لمنتج معين أو خدمة اختارها وفقاً لحجز المستخدم. وهذه الشروط
          للخدمة ملزمة على المستخدم.
        </p>
        <h3> الأهلية للاستخدام</h3>
        <p>
          يجب أن يكون المستخدم مؤهلا للوصول إلى الموقع الإلكتروني طبقا للقانون المعمول به في البلد.
          قبل استخدام الموقع الالكتروني أو الحصول على خدمات ميكمايتريب، يجب على المستخدم قراءة وفهم
          شروط الاستخدام هذه بشكل إلزامي، ويجب اعتباره موافقا لشروط الاستخدام كمستند ملزم يحكم
          تصرفات المستخدم ومعاملاته مع ميكمايتريب. وإن لم يوافق المستخدم بأي جزء من شروط الاستخدام
          فلا يمكن للمستخدم الاستفادة من خدمات ميكمايتريب ولا التصحف من موقعها على الويب. يجب أن
          يكون المستخدم مسجلا في منصة الشركة لتصفح موقعها أو الاستفادة من خدماتها بالغرض التجاري.
          يوافق المستخدم ويقر بأنه سيتعامل عبر المنصة للأغراض التجارية فقط غير الشخصية باستثناء
          موافقة مسبقة من الشركة. يمكن لمستخدم واحد تسجيل حساب واحد فقط على المنصة. وتحتفظ
          ميكمايتريب بالحق في إلغاء أو إنهاء حساب المستخدم إذا كان لدى الشركة أسباب تفيد في أن
          المستخدم سجل أو يتحكم في وقت واحد في حسابين أو أكثر. تقتصر جميع الحقوق والتزامات المستخدم
          والشركة فيما يتعلق بأي خدمات أومنتجات توفرها ميكمايتريب على نطاق شروط الاستخدام هذه.
        </p>
        <h3>المحتويات</h3>
        <p>
          جميع المحتويات المقدمة على الموقع الإلكتروني، بما في ذلك على سبيل المثال لا الحصر، السمعية
          والصور والبرامج والنصوص والرموز والشعارات والعلامات التجارية والرسومات والأشكال وحقوق
          قواعد البيانات والمحتويات المماثلة لهذه (يشار إليها في هذه الوثيقة بعبارة "المحتويات")
          مملوكة أو مرخصة لشركة ميكمايتريب كما أنها محمية بموجب قوانين الملكية الفكرية المعمول بها.
          لا يحق للمستخدم استخدام المحتوى أو نسخه أو استنساخه أو ترخيصه أو توزيعه أو تعديله أو بيعه
          أو نشره أو ترجمته إلكترونيا وغير ذلك لأي غرض آخر، باستثناء ما هو محدد هنا. ويفهم المستخدم
          أنه لن يكتسب بتصفح الموقع أو الاستفادة من الخدمات، أي حق أو مصلحة أو ملكية لاستخدام
          المحتوى.
          <br />
          يوافق المستخدم على اتباع كافة التعليمات التي تلزمها شركة ميكمايتريب من حين إلى لآخر وستحدد
          الطريقة التي يستخدم بها المستخدم المحتويات.
          <br />
          لا تمنح ميكمايتريب للمستخدم ترخيصا أو حقا أو إذنا لاستخدام هذه المحتويات في أي حال. و سيعد
          أي استخدام غير مصرح به للمحتوي انتهاكا للقانون المعمول به. تحترم ميكمايتريب حقوق الملكية
          الفكرية للآخرين. إذا لاحظت أي عمل من أعمال الانتهاك على الموقع، فنطلب منكم إرسال إشعار خطي
          إلينا والذي يجب أن يحتوي على المعلومات التالية؛
          <ul>
            <li> تحديد واضح للعمل المحمي بحقوق الطبع والنشر الذي تدعي أنه تم انتهاكه. </li>
            <li>
              {' '}
              موقع المواد على الموقع الإلكتروني، بما في ذلك على سبيل المثال لا الحصر رابط المادة
              المخالفة.
            </li>
            <li>الدليل على أن العمل المزعوم المحمي بحقوق الطبع والنشر ملك لك. </li>{' '}
            <li>بيانات الاتصال الخاصة بك.</li>
          </ul>
          <br />
          يمكن إرسال الإشعارات المذكورة أعلاه إلى ميكمايتريب عبر عنوان البريد الإلكتروني التالي:
          legal@makemytrip.com
        </p>
        <h3>الموقع الإلكتروني</h3>
        <p>
          الموقع الإلكتروني مخصص للاستخدام من قبل مستخدم (مستخدمين) حقيقي لأغراض توافق على القانون
          المعمول به. وهذا الموقع مملوك وخاضع لسيطرة وإدارة شركة ميكمايتريب ذ.م.م .
          <br />
          لا يحق المستخدم بتوزيع أو تبادل أو تعديل أو بيع أو نقل شيء من الموقع الإلكتروني، بما في
          ذلك على سبيل المثال أي نصوص أو صور أو سمعية أو فيديو لغرض تجاري أو عام. ولا يحاول المستخدم
          (المستخدمون) (أو يشجع أو يدعم محاولة شخص آخر) التحايل أو الهندسة العكسية أو إيجاد أعمال
          مشتقة من أية معلومات أو محتويات تم الحصول عليها من الموقع الإلكتروني لميكمايتريب أو
          استخدامها بشكل غير مصرح به.
          <br />
          تمنح شروط الاستخدام هذه حقا محدودا، وغير حصري وغير قابل للتحويل لاستخدام هذا الموقع
          الإلكتروني على النحو المسموح به صراحة في شروط الاستخدام هذه. يوافق المستخدم على عدم إعاقة
          أو محاولة إعاقة تشغيل الموقع بأي شكل من الأشكال.
          <br />
          قد يكون الوصول إلى بعض ميزات الموقع متاحا للمستخدم (المستخدمين) المسجلين فقط. قد تتطلب
          عملية التسجيل من المستخدم إجابة على أسئلة معينة أو تقديم معلومات معينة قد تكون أو لا تكون
          شخصية بطبيعتها. قد تكون بعض هذه الحقول إلزامية أو اختيارية. يمثل المستخدم ويتعهد بأن جميع
          المعلومات المقدمة إلى ميكمايتريب صحيحة ودقيقة.
          <br />
          تحتفظ ميكمايتريب وفقا لتقديرها الخاص بالحق في إنهاء حق المستخدم للدخول على الموقع والخدمات
          المقدمة عليه أو أي جزء منه في أي وقت دون إشعار مسبق، وذلك للصيانة العامة أو لأي سبب آخر.
          <br />
          <br />
          تستخدم ميكمايتريب كافة المساعي المعقولة تجاريا ليكون المحتوى الموجود على الموقع الخاص بها
          خاليا من أي فيروس أو برامج ضارة أخرى، إلا أن الشركة لا يمكنها ضمان عدم احتوائه من
          الفيروسات. إن أي بيانات أو معلومات يتم تنزيلها أو الحصول عليها من خلال استخدام الموقع وفقا
          لتقدير المستخدم ومسؤوليته بالكامل وسيكون وحده المسؤول عن أي ضرر يلحق بأنظمة الكمبيوتر
          الخاصة به أو فقدان البيانات التي قد تنتج بتنزيل هذه البيانات والمعلمومات.
          <br />
          تحتفظ ميكمايتريب بالحق في إجراء تحسينات أو تغييرات دورية على موقعها الإلكتروني في أي وقت
          كان بلا إشعار مسبق للمستخدم. إذ نطلب من المستخدم بإبلاغ أي محتوى في الموقع يعتبر غير
          قانوني أو مرفوضا أو تشهيريا أو تشويهيا أو فاحشا أو مضايقة متعديا على الحرية الشخصية او
          متعسفا أو مزورة أو الذي يعتبر ضد أي من المعتقدات الدينية أو بريدا غير مرغوب فيه أو انتهاكا
          لأي قانون معمول به إلي legal@makemytrip.com. عند استسلام هذا الإبلاع، تحتفظ ميكمايتريب
          بالحق في إجراء التحقق و/ أو اتخاذ الإجراء الذي قد تراه الشركة مناسبا.
        </p>
        <h3>حدود مسؤولية ميكمايتريب</h3>
        <p>
          تعمل ميكمايتريب دائما بمثابة مسهل من خلال ربط المستخدم بمقدمي الخدمات المعنيين مثل شركات
          الطيران والفنادق وما إلى ذلك. (يشار إليها في هذه الوثيقة بصورة جماعية "مزودي الخدمة").
          <br />
          من خلال إجراء الحجز، يقر المستخدم بأن ميكمايتريب توفر فقط منصة تقنية لحجز الخدمات
          والمنتجات وتقع المسؤولية النهائية على مقدمي الخدمة المعني وليس على الشركة. فبالتالي يكون
          اتفاق الخدمة النهائي بين المستخدم ومزود الخدمة. ويفهم المستخدم أن انتهاك القواعد واللوائح
          المتخذة من قبل مزود الخدمة قد يؤدي إلى إلغاء التذكرة أو الحجز.
          <br />
          تقتصر مسؤولية ميكمايتريب على تزويد المستخدم بحجز مؤكد حسب طلبه. في حالة عدم تأكيد الحجز
          لأي سبب من الأسباب التقنية (مثل تعطل الشبكة أو قطع الاتصال بمنصات الطرف الثالث مثل بوابات
          الدفع والبنوك وما إلى ذلك) أو أي إخفاقات أخرى مماثلة، فإن التزام ميكمايتريب يقتصر على
          استرداد قيمة مبلغ الحجز، إن وجد، المستلم من العميل. ويجب أن يؤدي رد الأموال هذا إلى إعفاء
          ميكمايتريب تماما من جميع الالتزامات المتعلقة بهذه المعاملة. ويتحمل المستخدم المسؤوليات
          الإضافية، إن وجدت.
          <br />
          أي مشاكل أو مخاوف يواجهها المستخدم وقت الاستفادة من أي من هذه الخدمات ستكون المسؤولية
          لمقدم الخدمة فقط. ولن تتحمل ميكمايتريب مسؤولية فيما يتعلق بالأفعال إو الإهمالات أو الأخطاء
          أو الإقرارات أو الضمانات أو الانتهاكات أو الإهمال من جانب مزودي الخدمة أو أي إلغاء أو
          إعادة جدولة أو تأخير في أدءا الخدمات الواردة أدناه هنا.
          <br />
          ما لم تلتزم ميكمايتريب صراحة في إطار جزء من أي منتج أو خدمة، بأنها لا تتحمل أية مسؤولية
          على مستوى الخدمة أو جودتها أو ملاءمتها أو توفرها على النحو الذي يقدمه مزودو الخدمة
          المعنييون. علاوة على ذلك لن تكون ميكمايتريب مسؤولة إذا لم تعد الخدمة التي يتم إجراء الحجز
          من أ.جلها متاحة أو تم بيعها وقت إتمام المعاملة على الموقع الإلكتروني.
          <br />
          يفهم المستخدم أن ميكمايتريب لن تكون مسؤولة على صحة أو دقة المعلومات المعروضة على الموقع من
          جهات خارجية أو تعارضها مع أي قوانين أو لوائح سارية. لن تكون ميكمايتريب بأي حال من الأحوال
          مسؤولة عن الأضرار الناجمة عن فقدان الاستخدام أو البيانات أو الأرباح أو المبيعات أو
          الإيرادات أو خسارة المدخرات المتوقعة أو ضياع فرص العمل أو الشهرة أو السمعة أو أي أضرار
          مباشرة أو غير مباشرة أو عقابية أو عرضية أو خاصة أو تبعية، الناشئة عن أو المرتبطة باستخدام
          أو أداء الموقع الإلكتروني بأي شكل من الأشكال. مع مراعاة الحد المسموح بالقوانين المعمول
          بها، يقتصر الحد الأقصى للمسؤولية الإجمالية لميكمايتريب بموجب شروط الاستخدام هذه على مبلغ
          الحجز المدفوع لإجراء الحجز الذي نشأ عنه النزاع.
        </p>
        <h3>مسؤولية المستخدم</h3>
        <p>
          يفهم المستخدم أن مسؤولية تصفح الموقع واستفادة الخدمات منه تقع على عاتقه وحده كما أنه ينصح
          للتحقق من وصف الخدمات والمنتجات بعناية قبل الحجز. ويوافق المستخدم ( المستخدمون) على
          الالتزام بجميع الشروط الواردة في تأكيد الحجز أو على النحو المنصوص عليه في قسيمة الحجز
          المؤكدة. ويجب أيضا قراءة هذه الشروط بالإضافة إلى شروط الخدمة واللوائح الخاصة بمقدمي الخدمة
          المعنيين كما هو منصوص على الموقع الإكتروني.
          <br />
          إذا نوى المستخدم إجراء الحجز نيابة عن طرف ثالث فسيكون من مسؤولية المستخدم إبلاغ هذا الطرف
          الثالث بشروط الاستخدام هذه، بما في ذلك جميع القواعد والقيود المطبقة عليه.
          <br />
          يتعهد المستخدم بالالتزام بجميع الإجراءات والإرشادات، والتي يتم تعديلها من وقت لآخر، فيما
          يتعلق باستخدام الخدمات المتاحة من ميكمايتريب. كما يتعهد بالامتثال لجميع القوانين واللوائح
          المعمول بها لأي هيئة قانونية أو تنظيمية مخولة للقيام بذلك لاستفادة الخدمات أو لكل معاملة.
          <br />
          يوافق المستخدم على عدم استخدام أو السماح لأطراف ثالثة لاستفادة الخدمات وكذلك الموقع
          الإلكتروني لأغراض أخرى غير المنصوص عليه في شروط الاستخدام هذه. بالإضافة إلى ذلك يوافق
          المستخدم على عدم السماح للأطراف الثالثة بما يلي:
          <br />
          <ul>
            <li> الكشف عن أي بيانات اعتماد لتسجيل الدخول أو إعادة بيعها إلى طرف ثالث. </li>{' '}
            <li>استخدام الموقع أو الاستفادة من الخدمات لغرض تجاري غير مصرح به. </li>{' '}
            <li>القيام بعمل حجوزات مضاربة أو زائفة أو بقصد الاحتيال </li> الوصول إلى أو مراقبة أو
            نسخ محتوى أو معلومات على الموقع الإلكتروني باستخدام روبوت أو عنكبوت أو كاشطة برمجية أو
            غيرها من الوسائل الآلية أو أي عملية يدوية لأي غرض دون إذن خطي صريح مسبق من ميكمايتريب.
            القيام بما من شأنه إضرار بعمل المادة المتاحة على الموقع أو يعرقل الدخول عليها أو يعترضها
            أو يفسدها أو فعل شيء يفرض أو قد يفرض وفقا لتقدير الشركة حملا لا داعي له أو حملا أكبر من
            اللازم للبنية التحتية المتعلقة بها.{' '}
            <li> إجراء الهندسة العكسية لأية ميزات أو خدمات مقدمة من قبل ميكمايتريب أو تفكيكه. </li>{' '}
            <li>
              الحصول أو محاولة الحصول على معلومات بأي وسيلة لم يتم توفيرها عن قصد من خلال الموقع
              الإلكتروني.
            </li>{' '}
            <li>
              إعادة بيع أو استخدام أو نسخ أو مراقبة أو عرض أو تنزيل أو إعادة إنتاج أي محتوى أو
              معلومات أو برامج أو منتجات أو خدمات متاحة على الموقع لغرض تجاري أو تنافسي.
            </li>{' '}
            الانخراط في تأطير جزء من الموقع إلى قناة أخرى أو موقع آخر دون إذن خطي مسبق من
            ميكمايتريب.{' '}
            <li>
              {' '}
              تقديم مواد تنتهك حقوق الملكية الفكرية أو حقوق أي طرف ثالث بشكل مباشر أو غير مباشر.
            </li>{' '}
            محاولة انتحال شخصية أو شخص آخر بغرض تحريف أو خداع أو التصرف بطريقة غير قانونية بغرض غير
            قانوني. إرسال رسائل بريد إلكتروني غير مرغوب فيها إلى طرف ثالث.{' '}
            <li>
              {' '}
              رفع مادة تحتوي على فيروسات خاصة بالحاسبات أو أية أكواد إلكترونية أخرى على أنظمة
              ميكمايتريب.{' '}
            </li>
            <li> التصرف بطريقة يمكن إلحاق الضرر بموقع الويب أو بسعمة ميكمايتريب. </li>
            <li>
              {' '}
              استخدام الخدمات على موقع الويب بما ينتهك القوانين المعمول بها بما في ذلك حقوق الآخرين.
              ويشمل ذلك أيضا تحميل محتوى ينتهك حقوق الملكية الفكرية لطرف ثالث.
            </li>
          </ul>
          {`
            إخلاء المسؤولية: 
قد تحتوي المواد الموجودة على هذا الموقع أخطاء تقنية أو مطبعية. وتقوم ميكمايتريب بإجراء تغييرات أو تحسينات في أي وقت.

تقدم الخدمات على قدر "كما هي" و"حسب توفيرها". قد تغير ميكمايتريب ميزات أو وظائف الخدمات المقدمة في أي وقت، وفقا لتقديرها الخاص، بدون أي إشعار مسبق إلى حد أقصى تسمح به القوانين الإلزامية السارية. تتنصل ميكمايتريب مسؤوليتها صراحة عن جميع الضمانات من أي نوع، سواء كانت صريحة أو ضمنية، بما في ذلك على سبيل المثال لا الحصر، ضمان المعلومات أو البيانات وأي ضمانات تتعلق بتوافر المعلومات ودقتها ومدى فائدتها أو محتواها وأي ضمانات بالملكية أو عدم الانتهاك أو القابلية للتسويق. لن تنشئ أي نصيحة أو معلومات، سواء كانت شفهية أو خطية، يحصل عليها المستخدم من ميكمايتريب أو من خلال الخدمات المختارة، أي ضمان غير منصوص عليه صراحة في هذه الوثيقة أو في شروط وأحكام الخدمات.
يقر المستخدم بأن هذا الموقع يتم توفيره فقط على الأساس المنصوص عليه في شروط الاستخدام هذه. قد يتم منع حق المستخدم للدخول على الموقع أو استخدامه دون انقطاع على هذا الأساس من خلال عوامل معينة خارجة عن سيطرة الشركة المعقولة بما في ذلك، على سبيل المثال لا الحصر، عدم توفر أو عدم تشغيل أو انقطاع الإنترنت أو خدمات الاتصالات الأخرى أو نتيجة لأي صيانة أو خدمة أخرى يتم تنفيذها على الموقع. ولن تكون ميكمايتريب مسؤولة عن أي خسارة أو ضرر من أي نوع ينشأ عن أو فيما يتعلق بأي باستخدام الموقع الإلكتروني.
يفوض المستخدم أيضًا لممثل ميكمايتريب بالتواصل مع هذا المستخدم عبر المكالمات الهاتفية والرسائل النصية القصيرة والبريد الإلكتروني بما في ذلك لتسويق الخدمات التي يوفرها المستخدم أو تلك التي تشبه أو يمكن مقارنتها مع هذه الخدمات أو تلك الخدمات التي نشعر أنها قد تهمك. إن دخول المستخدم المتواصل على الموقع يعني إشارة صريحة إلى موافقته على تلقي مثل هذه الاتصالات. يجب أن تحل هذه الموافقة محل أي تفضيلات يحددها هذا المستخدم سجل عدم الاتصال (DNCR) أو أي تفضيلات أخرى مماثلة.

          `}
        </p>
        <h3>المعلومات المتعلقة بالأمان والحساب</h3>
        <p>
          أثناء التسجيل علي الموقع الإلكتروني، سيتعين على المستخدم اختيار كلمة السر للوصول إلى حساب
          هذا المستخدم ويكون المستخدم وحده مسؤولا عن الحفاظ على سرية كل من كلمة المرور والحساب وكذلك
          عن جميع الأنشطة في الحساب. ومن واجب المستخدم إبلاغ ميكمايتريب على الفور بشكل خطي بأي
          استخدام غير مصرح به لكلمة المرور أو الحساب أو أي خرق آخر للأمن. ولن تكون ميكمايتريب مسؤولة
          عن أي خسارة حدثت من المستخدم نتيجة استخدام غير مصرح بكلمة المرور أو الحساب، سواء بعلم
          المستخدم أو بدون علمه. ولا يجوز للمستخدم استخدام حساب أي شخص آخر في أي وقت. ويجب إبلاغ (.)
          على الفور بأي خسارة أو سوء استخدام لبيانات اعتماد تسجيل الدخول. يقر المستخدم بأن المعلومات
          الشخصية (كما هو مقرر في سياسة الخصوصية) المقدمة إلى أو عبر خدمات ميكمايتريب أو موقع الويب
          الخاصة بها يمكن استخدامها للشركة وفقا لسياسة الخصوصية والقوانين المعمول بها. ويوافق
          المستخدم على التأكد من أن جميع المعلومات الشخصية المقدمة دقيقة ومحدثة وأن المستخدم يمتلك
          جميع الموافقات أو التراخيص أو الموافقات اللازمة لسماح ميكمايتريب باستخدام تلك المعلومات
          وفقا لشروط الاستخدام هذه وسياسة الخصوصية والأحكام والقوانين السارية.
        </p>
        <h3>الرسوم والدفع</h3>
        <p>
          يتحمل المستخدم المسؤولية الكاملة عن جميع المدفوعات والرسوم والضرائب والتكاليف الناشئة عن
          استخدام الخدمة، وفقا للقوانين المعمول بها. بالإضافة إلى تكلفة الحجز التى يتقاضاها مقدمو
          الخدمة، تحتفظ ميكمايتريب بالحق في فرض رسوم معينة في إطار طبيعة رسوم الخدمة أو أي رسوم
          أخرى. كما تحتفظ الشركة بالحق لتعديل أي أو جميع الرسوم من وقت إلى آخر. سيتم عرض أي رسوم
          إضافية، بما في ذلك الرسوم مقابل أي تعديلات عليها، للمستخدم قبل تأكيد الحجز أو تحصيل
          المدفوعات من هذا المستخدم. في حالات فرض رسوم قصيرة على مبلغ الحجز والضرائب والرسوم
          القانونية ورسوم الراحة وما إلى ذلك، بسبب خطأ تقني أو سبب آخر، تحتفظ ميكمايتريب بالحق في
          خصم أو تحصيل أو المطالبة بالمبلغ المتبقي من المستخدم ويجب على المستخدم دفع مبلغ الرصيد هذا
          إلى ميكمايتريب. وفي الحالات التي يتم فيها المطالبة بالرسوم القصيرة قبل استخدام الحجز،
          سيكون لشركة ميكمايتريب الحرية في إلغاء هذه الحجوزات إذا لم يتم دفع المبلغ قبل تاريخ
          الاستخدام. يجب أن يتحمل المستخدم أي زيادة تفرضه ميكمايتريب على حساب التغيير في معدل
          الضرائب أو فرض ضرائب جديدة والرسوم الحكومية. قد يكون فرض الضرائب والرسوم بدون إشعار مسبق
          ويمكن أيضا أن تكون بأثر رجعي ولكنها ستكون دائما وفقا للقانون المعمول به. في الظروف النادرة
          المتمثلة في عدم تأكيد الحجز لأي سبب من الأسباب، ستقوم ميكمايتريب بمعالجة استرداد مبلغ
          الحجز الذي دفعه المستخدم وإبلاغه بنفس الشيء. وليس في حق ميكمايتريب توفير حجز بديل بدلا من
          الحجز غير المؤكد أو تعويضه أو استبداله. سيعتبر جميع الججوزات اللاحقة كحجوزات جديدة. سيتم
          معالجة أي استرداد قابل للتطبيق وفقا للسياسيات المحددة لمقدم الخدمة وميكمايتريب حسب الحالة.
          يقر المستخدم ويوافق على أن جميع المدفوعات يجب أن تتم في الحسابات المصرفية الخاصة
          لميكمايتريب فقط. لا تطلب ميكمايتريب أو وكلاؤها أو ممثلوها أو موظفوها مطلقا من أي مستخدم
          تحويل الأموال إلى أي حساب خاص أو إلى حساب ليس باسم الشركة. يوافق المستخدم على أنه إذا قام
          بتحويل أي مبلغ إلى أي حساب مصرفي غير مملوك لميكمايتريب بشكل شرعي أو إلى أي حساب شخصي لشخص
          آخر، فلن تتحمل الشركة المسؤولية عن ذلك . لا يحق للمستخدم أن يسترد من ميكمايتريب أي مبلغ
          ينقله المستخدم إلى أي طرف ثالث. لن يقوم المستخدم بمشاركة معلوماته الشخصية الحساسة مثل رقم
          بطاقة الائتمان/الخصم ورمز حماية البطاقة وكلمة السر لمرة واحدة وتاريخ انتهاء صلاحية البطاقة
          ومعرفات المستخدم وكلمات السر وما إلى ذلك مع أي شخص آخر بما في ذلك وكلاء أو موظفين أو
          ممثلين لميمكمايتريب. يجب على المستخدم إبلاغ الشركة على الفور إذا طلب أي من موظفي أو ممثلي
          أوكلائها هذه التفاصيل. ولن تكون الشركة مسؤولة عن أي خسارة ناجمة عن مشاركة البيانات
          المذكورة أعلاه. ستتم دائما رد المبالغ المستردة، إن وجدت، على الحجوزات الملغاة إلى الحساب
          المعني أو الأداة المصرفية (بطاقة الائتمان، المحفظة وما إلى ذلك) التي تم الدفع من خلالها
          لهذا الحجز. لن تتحمل شركة ميكمايتريب تحت أي ظرف من الظروف المسؤولية إذا فات المستخدم رحلته
          أو عجز عن الحضور في الموعد المحدد أو لأي حجوزات غير مستخدمة. وسيكون استرداد الأموال - إن
          وجد في مثل هذه الحالات - وفقاً لسياسة شركة الخطوط الجوية المعمول بها، كما سيتم رده إلى
          المستخدم عند استلام المبلغ من شركة الخطوط الجوية المعنية. إذ ننصح المستخدم بتقديم الطلب
          لاسترداد الأموال في غضون 180 يوماً بعد تاريخ تسجيل الوصول، وإلا فسيتم مصادرة جميع المبالغ
          المستردة مقابل عدم الحضور أو الحجوزات غير المستخدمة. يخضع الحجز (الحجوزات) التي أجراها
          المستخدم من خلال ميكمايتريب لسياسة الإلغاء المعمول بها على النحو المبين في صفحة الحجز أو
          كما يتم إبلاغ العملاء كتابيا. توفر ميكمايتريب مجموعة من خيارات الدفع بما في ذلك بطاقات
          الائتمان وبطاقات الخصم من البنوك المختلفة والتحويل المصرفي عبر الإنترنت لجميع البنوك
          الكبرى ومحفظة ميكمايتريب ومحفظة الأطراف الثالثة وبطاقة الهدايا والمزيد. سيتم الاحتفاظ
          بالأموال المودعة في محفظة ميكمايتريب من قبل المستخدم بنفس الشكل والعملة اللذين تم
          إيداعهما، ويمكن استخدام هذا المبلغ للمستخدم لسداد مدفوعات للحجوزات التي تتم إجراؤها من
          خلال الموقع الإلكتروني وفقا لشروط الخدمة هذه.
        </p>
        <h3>استخدام رقم الهاتف المحمول وتفاصيل اتصال المستخدم لميكمايتريب. </h3>
        <p>
          سترسل ميكمايتريب تأكيد الحجز وطلب الإلغاء وتأكيد الدفع وحالة الاسترداد وتغيير الجدول
          الزمني أو أي معلومات أخرى تتصل بالمعاملة أو الحجز الذي أجراها المستخدم، عبر الرسائل
          القصيرة وتطبيقات المراسلة عبر الإنترنت مثل واتساب والمكالمة الصوتية والبريد الإلكتروني أو
          أي تفاصيل اتصال بديلة أخرى يقدمها المستخدم في وقت الحجز. قد تتصل ميكمايتريب أيضا بالمستخدم
          أثناء الحالات المذكورة أعلاه فيما يتعلق بالحجوزات المعلقة أو الفاشلة، لمعرفة تفضيل
          المستخدم لإتمام الحجز وأيضا لمساعدة المستخدم في ذلك.
          <br />
          يوافق المستخدم بموجب هذا دون قيد أو شرط على أن مثل هذه الاتصالات عبر الرسائل القصيرة أو
          تطبيقات المراسلة القائمة على الانترنت مثل واتساب أو المكالمات الصوتية أو البريد الإلكتروني
          أو أي وضع آخر لميكمايتريب :
          <ul>
            <li>بناء على طلب وتفويض المستخدم</li>
            <li>
              وتعد "المعاملات" وليست "ترويجية" وفقا للقوانين المحلية، والامتثال للمبادء التوجيهية
              الصادرة عن هيئة تنظيم الاتصالات والحكومة الرقمية في الإمارات العربية المتحدة (“TDRA”).
            </li>
            <li>
              الامتثال للإرشادات الصادرة من هيئة تنظيم الاتصالات والحكومة الرقمية في الإمارات
              العربية المتحدة (“TDRA”) أو أي سلطة أخري مختصة.
            </li>
          </ul>
          سيقوم المستخدم بتعويض ميكمايتريب عن جميع أنواع الخسائر والأضرار التي تكبدتها الشركة بسبب
          أي إجراء تتخذه هيئة تنظيم الاتصالات والحكومة الرقمية في الإمارات العربية المتحدة (TDRA) أو
          أي سلطة أخرى بسبب أي شكوى خاطئة يقدمها المستخدم على ميكمايتريب فيما يتعلق بالاتصالات
          المذكورة أعلاه أو بسبب رقم أو معرف بريد إلكتروني خاطئ يقدمه المستخدم لأي سبب من الأسباب
        </p>
        <h3>التأمين</h3>
        <p>
          ما لم تنص ميكمايتريب صراحة على أي خدمة معينة، فإن الحصول على تغطية تأمينية كافية هو من
          التزام المستخدم. ولا تقبل ميكمايتريب بأي حال من الأحوال أي مطالبات ناشئة عن مثل هذه
          السيناريوهات.
          <br />
          يجب أن يكون التأمين، إن وجد كجزء من الخدمة أو المنتج بواسطة ميكمايتريب، وفقا لشروط وأحكام
          شركة التأمين التابعة لجهة خارجية. تعمل ميكمايتريب كمجرد مسهل في ربط المستخدم بشركة
          التأمين. يجب على المستخدم الاتصال بشركة التأمين مباشرة لأي مطالبات أو نزاعات. ولن تكون
          ميكمايتريب مسؤولة في حالة القبول الجزئي أو الرفض للمطالبات من قبل شركات التأمين.
          <br />
        </p>
        <h3>الالتزامات للحصول على تأشيرات</h3>
        <p>
          تخضع الحجوزات الدولية بواسطة ميكمايتريب لمتطلبات التأشيرة بما في ذلك على سبيل المثال لا
          الحصر تأشيرة العبور، OK TO BOARD. وتقع على عاتق المستخدم مسؤولية الحصول على هذه الأشياء
          وفقا لمتطلبات حجوزات السفر ومتطلبات البلدان التي ينوي زيارتها أو العبور فيها.
          <br />
          ولن تكون ميكمايتريب مسؤولة عن أي مشكلات، بما في ذلك عدم القدرة على السفر، والتي تنشأ عن
          متطلبات التأشيرة كما أنها لن تكون مسؤولة عن رد أي مبلغ إلى المستخدم لعدم قدرته على
          الاستفادة من الحجز بسبب غياب التأشيرة أو رفضها، بغض النظر عما إذا كان المستخدم قد استفاد
          من خدمات ميكمايتريب لعملية التأشيرة أم لا. سيكون استرداد الأموال، إن وجد، وفقا لشروط الحجز
          وسياسة الإلغاء المعمول بها.
        </p>
        <h3>ظروف القوة القاهرة</h3>
        <p>
          يمكن أن يكون هناك ظروف استثنائية حيث قد لا تتمكن ميكمايتريب و/أو مقدمو الخدمة من الوفاء
          بالحجوزات المؤكدة لأسباب مختلفة مثل عمل إلهي واضطرابات عمالية والإفلاس ومتطلبات العمل،
          والقرارات الحكومية والنشاطات الإرهابية وأي مشاكل تشغيلية وتقنية وإلغاء المسار والرحلات وما
          إلى ذلك أو لأي سبب آخر خارج عن سيطرة ميكمايتريب. إذا كانت لدى ميكمايتريب معرفة مسبقة بأي
          من هذه الحالات التي قد يحدث فيها عدم احترام للحجوزات، فستبذل قصارى جهدها لتوفير بديل مماثل
          للمستخدم أو رد مبلغ الحجز بعد خصم رسوم الخدمة المطبقة، إذا تم دعمها واستردادها من قبل
          مشغلي الخدمة المعنيين. يوافق المستخدم على أن ميكمايتريب مع كونها مجرد وسيلة التسهيل
          للخدمات والمنتجات المحجوزة، لا يمكن أن تكون مسؤولة عن أي ظرف من ظروف القوة القاهرة. يجب
          على المستخدم الاتصال مع مقدم الخدمة مباشرة للحصول على أي قرارات أخرى واسترداد الأموال.
        </p>
        <h3>الإعلانات على ميكمايتريب والطرف الثالث والمواقع المرتبطة</h3>
        <p>
          قد يحتوي هذا الموقع على روابط أو مؤشرات لمزودي الخدمة أو مواقع طرف ثالث ("مواقع الطرف
          الثالث"). وتوفر ميكمايتريب هذه الروابط من الجهات الخارجية للمستخدمين للتسهيل عليهم فقط.
          ولا تقوم ميكمايتريب بأي شكل من الأشكال، بإدارة أية معلومات أو منتجات أو خدمات أو التكحم في
          مثل تلك المعلومات أو الخدمات التي تخص لجهات أخرى. إذا قام المستخدم بالوصول إلى أي موقع
          تابع لجهة خارجية، فتتحمل وحده مسؤولية استخدامه تلك الخدمات، ولن تتحمل ميكمايتريب أي
          مسؤولية عن ذلك.
          <br />
          ميكمايتريب ليست مسؤولة عن أي أخطاء أو سهو أو إقرارات كاذبة على أي من صفحاتها أو روابطها أو
          أي صفحات موقع مرتبط (إلى الحد الذي يتم فيه تحديث هذه المعلومات أو تقديمها مباشرة من قبل
          مقدمي الخدمة أو المعلنين) و/ أو على مواقع الطرف الثالث.
          <br />
          لا تتعامل ميكمايتريب مع أي خدمة أو توفيرها للدول المحظورة من قبل مكتب مراقبة الأصول
          الأجنبية (OFAC) وفقا لقانون دولة الإمارات المتحدة.
        </p>
        <h3>الحق في الرفض</h3>
        <p>
          تحتفظ ميكمايتريب وفقًا لتقديرها الخاص بالحق في عدم قبول أي حجز دون إبداء أي سبب لذلك.
          <br />
          لن تقدم ميكمايتريب أي خدمة أو تشارك تفاصيل الحجز المؤكد إلى أن يتم استلام الاعتبار الكامل
          من المستخدم.
          <br />
          بالإضافة إلى سبل الحل والمطالبات الأخرى المتاحة لـميكمايتريب بموجب شروط الاستخدام هذه أو
          بموجب القانون المعمول به، يحق لميكمايتريب تقييد نشاط المستخدم أو تحذير المستخدمين الآخرين
          من إجراءات المستخدم أو تعليق تسجيل المستخدم أو إنهائه على الفور أو رفض منح المستخدم حق
          الوصول إلى الموقع إذا:
          <ul>
            <li>قام المستخدم بخرق شروط الاستخدام هذه.</li>
            <li>إن لم تتمكن ميكمايتريب من التحقق أو المصادقة على أي معلومات يقدمها المستخدم.</li>
            <li>
              اعتقدت ميكمايتريب أن المستخدم انخرط في فعل ما من شأنه انتهاك حقوق أي طرف ثالث أو أي
              قانون معمول به أو فعل شيئا يمكن أن يشكل التزاما على المستخدم أو المستخدمين الآخرين
              لميكمايتريب أو للشركة نفسها.
            </li>
          </ul>
          بمجرد تعليق المستخدم أو إنهائه من استخدام الموقع، لا يجوز لهذا المستخدم التسجيل أو محاولة
          التسجيل مع ميكمايتريب ببيانات مختلفة، أو استخدام هذا الموقع بأي شكل من الاشكال حتى تتم
          إعادة هذا المستخدم بواسطة ميكمايتريب. يتم اتخاذ قرار إعادة المستخدم المعلق وفقا لتقدير
          ميكمايتريب وحدها.
          <br />
          إذا قام أحد المستخدمين بخرق شروط الاستخدام هذه، فإن ميكمايتريب تحتفظ بالحق في استرداد أي
          مبالغ مستحقة الدفع من قبل المستخدم لميكمايتريب (عن طريق تسوية أي مبلغ مستحق من المستخدم
          لميكمايتريب بموجب هذه الاتفاقية) واتخاذ الإجراءات القانونية المناسبة حسبما تراه ضروريًا.
          لا يجوز للمستخدم كتابة أو إرسال أي محتوى إلى ميكمايتريب أو التواصل مع الشركة باستخدام
          الكلمات التي تلي:
          <ul>
            <li>
              مادة ضارة تتضمن تهديد أو إساءة للاستخدام أو معلومات تتضمن تشهير أو محتوى عدائي أو ما
              يخالف القوانين والأعراف أو ما ينطوي على عدم الاحتشام أو تمجيد للعنف.
            </li>
            <li> مادة مخالفة لأي قانون معمول به.</li>
            <li> البريد الإلكتروني التافه أو غير المرغوب فيه.</li>
            <li>
              مادة تحتوي على فيروسات أو برامج ضارة أو ملفات تالفة أو أي برامج أخرى مماثلة قد تلحق
              الضرر بموقع الويب.
            </li>
            <li> تزوير أصل أو مصدر البرامج أو المواد الأخرى الموجودة في الملف الذي تم تحميله.</li>
            <li> مخالفة الشروط والأحكام بموجب شروط الاستخدام هذه أو القانون المعمول به.</li>
          </ul>
          إذا انتهك المستخدم أيًا من الشروط المذكورة أعلاه، فإن ميكمايتريب لها الحرية في اتخاذ
          الإجراء القانوني المناسب ضد المستخدم.
        </p>
        <h3>حق الالغاء</h3>
        <p>
          يتعهد المستخدم صراحةً بتزويد ميكمايتريب بالمعلومات الصحيحة أثناء استخدام هذا الموقع بموجب
          شروط الاستخدام هذه، وعدم تقديم أي تحريف للمعلومات. أي تقصير من جانب المستخدم يمنعه من
          الاستفادة من الخدمات من ميكمايتريب. في حالة اكتشاف ميكمايتريب أو في حالة وجود أسباب
          للاعتقاد في أي وقت أثناء أو بعد تلقي طلب للحصول على خدمات من المستخدم أن طلب الخدمات إما
          غير مصرح به أو أن المعلومات المقدمة من قبل المستخدم أو أي من المسافرين غير صحيحة أو أن أي
          حقيقة تم تحريفه من قبل هذا المستخدم، يحق لـميكمايتريب الحصول على تعويضات قانونية مناسبة ضد
          المستخدم، بما في ذلك إلغاء الحجوزات، دون أي إخطار مسبق للمستخدم. في مثل هذه الحالة، لن
          تكون ميكمايتريب مسؤولة عن أي خسارة أو ضرر قد يحدث للمستخدم أو أي شخص آخر في الحجز، نتيجة
          لهذا الإلغاء للحجز أو الخدمات. في حالة قيام أي وكالة قضائية أو شبه قضائية أو وكالة تحقيق
          أو سلطة حكومية بالتواصل مع ميكمايتريب لإلغاء أي حجز ، فإن ميكمايتريب ستلغيه دون الرجوع إلى
          المستخدم. لا يجوز للمستخدم تحميل ميكمايتريب المسؤولية عن أي خسارة أو ضرر ناشئة من التدابير
          التي اتخذتها ميكمايتريب لحماية مصلحتها ومصالح عملائها الحقيقيين. قد يشمل ذلك أيضًا رفض
          ميكمايتريب أو إلغائه لأي حجوزات بسبب معاملات الاحتيال المشتبه بها.
        </p>
        <h3>
          الاتصالات الزائفة والتصيد الاحتيالي أو البريد التطفلي وغيرها من الأنشطة الاحتيالية
          المماثلة
        </h3>
        <p>
          لن يقوم موظفو ميكمايتريب أو الممثلون المعتمدون أبدًا بالاتصال بالمستخدم لطلب رقم بطاقة
          الائتمان أو الخصم الخاصة به/ بها، وتاريخ انتهاء الصلاحية، ورقم التحقق على البطاقة وتسجيل
          الدخول المصرفي الإلكتروني، وكلمات المرور، وكلمة مرور لمرة واحدة (أو تي بي) وما إلى ذلك،
          ولن يطلبوا أبدًا تحويل الأموال إلى حساب مصرفي شخصي أو حساب مصرفي فردي. علاوة على ذلك، لن
          يطلبوا أيضًا من المستخدم تثبيت أي تطبيقات تابعة لجهات خارجية تمكنهم من عرض شاشة الهاتف
          المحمول أو الكمبيوتر الخاص بالمستخدم. قد يجعلك التصرف بناءً على أي من هذه الطلبات ضحية
          للاحتيال، وقد يؤدي إلى فقدان أموالك أو معلوماتك القيمة. إذا طُلب منك أي من المعلومات
          المذكورة أعلاه، فيرجى الإبلاغ عنها على الفور على legal@makemytrip.com. يوافق المستخدم ويقر
          بأن ميكمايتريب لن تكون مسؤولة عن أي خسارة أو ضرر يتكبده المستخدم فيما يتعلق بالحالات
          السابقة.
        </p>
        <h3>الشروط والأحكام المتعلقة بكوفيد - 19:</h3>
        <p>
          يوافق المستخدم على أنه نظرًا لانتشار جائحة كوفيد - 19 مؤخرًا، فقد تكون هناك حالات، حيث
          يقوم مزود الخدمة النهائية إما بإلغاء الحجز أو رفض تقديم الخدمات، وفقًا لما تم الاتفاق عليه
          مع المستخدم (بما في ذلك دون تحديد أي سبب محدد لهذا الرفض). قد يكون رفض الخدمة لأسباب تشمل
          على سبيل المثال لا الحصر المستخدم:
          <ul>
            <li> ظهور أي أعراض مرتبطة بـكوفيد -19</li>
            <li>
              رفض الامتثال لإرشادات السلامة، مثل ارتداء ملابس واقية والامتثال لمعايير التباعد
              الاجتماعي وما إلى ذلك.
            </li>
            <li> المعاناة من أي مرض يجعل المستخدم عرضة للفيروس</li>
            <li>شكل خطرا على صحة وسلامة الآخرين</li>
          </ul>
          في جميع هذه الحالات، لن تتحمل ميكمايتريب أي مسؤولية عن رفض الخدمة من قبل مزود الخدمة
          النهائي. يوافق المستخدم أيضًا على أن إعادة الأموال، إن وجدت، لمثل هذه الحجوزات ستتم
          معالجتها بواسطة ميكمايتريب للمستخدم شريطة استلامه من مزود الخدمة النهائي وفقا للسياسة
          الداخلية لمقدم الخدمة. يوافق المستخدم ويتعهد بالامتثال لجميع القواعد / اللوائح / الإرشادات
          أو إجراءات التشغيل القياسية (SOP) التي يتعين على المسافر اتباعها وفقا للقوانين المعلمول
          بها في جميع الولايات القضائية ذات الصلة،من أجل الاستفادة من الخدمات المحجوزة.
        </p>
        <h3>الشروط المتنوعة</h3>
        <p>
          القابلية للفصل: إذا تم تحديد أي بند من أحكام اتفاقية المستخدم هذه على أنه غير صالح أو غير
          قابل للتنفيذ كليًا أو جزئيًا، فإن مثل هذا البطلان أو عدم قابلية الإنفاذ يجب أن يرتبط فقط
          بهذا الحكم أو جزء من هذا الحكم. والجزء المتبقي وجميع الأحكام الأخرى يجب أن تظل سارية
          المفعول.
          <br />
          الاختصاص القضائي: ستخضع اتفاقية المستخدم هذه ويتم تفسيرها وفقا لقوانين دولة الإمارات
          العربية المتحدة ("الإمارات العربية المتحدة")، ويجب على الأطراف إحالة أي نزاعات لم يتم حلها
          إلى الاختصاص القضائي الحصري للمحاكم في دبي، الإمارات العربية المتحدة.
          <br />
          <br />
          تعديل شروط الاستخدام: تحتفظ شركة ميكمايتريب بالحق في تغيير شروط الاستخدام من وقت لآخر.
          ويكون على المستخدم إعادة قراءة شروط الاستخدام ليتأكد من استيعاب لكافة التغييرات الجديدة.
          وبناءَ على ذلك فإن مواصلة دخول المستخدم إلى المواقع الإلكترونية واستخدامها بعد إدخال تغيير
          عليها سوف تعتبر موافقة منه على شروط الاستخدام المعدلة.
          <br />
          السرية: أي معلومات تم ذكرها على وجه التحديد بواسطة ميكمايتريب على أنها سرية يجب أن يحتفظ
          بها المستخدم بسرية ولن يتم الكشف عنها ما لم يكن ذلك مطلوبًا بموجب القانون أو لخدمة الغرض
          من شروط الاستخدام هذه والتزامات كلا الطرفين.
          <br />
          سياسة الخصوصية: يجب على المستخدم الرجوع إلى سياسة الخصوصية الخاصة بـميكمايتريب والمتاحة
          على موقع ميكمايتريب. يوافق المستخدم على شروط سياسة الخصوصية وبالتالي يوافق على استخدام
          المعلومات الشخصية للمستخدم بواسطة ميكمايتريب والشركات التابعة لها وفقًا لشروط سياسة
          الخصوصية.
        </p>
        <S.PrivacyHeaderHeading>
          <h2>شروط الخدمة </h2>
        </S.PrivacyHeaderHeading>
        <h3>تذاكر الطيران</h3>
        <b>شروط شركات الطيران </b>
        <br />
        تخضع تذاكر الطيران المتاحة من خلال الموقع الالكتروني لأحكام وشروط شركة الطيران المعنية، بما
        في ذلك على سبيل المثال لا الحصر، سياسات الإلغاء والاسترداد.
        <br />
        تعمل شركة ميكمايتريب كمسهل لتمكين المستخدم لحجز تذكرة الطيران. ويكون عقد الخدمة لاستخدام
        خدمة الطيران دائمًا بين المستخدم وشركة الطيران المعنية
        <br />
        نحن نوصي المستخدمين بالرجوع إلى أحكام وشروط شركات الطيران قبل أن يقوم بعملية الحجز. ويوافق
        المستخدم بمجرد تأكيد التذكرة على الالتزام بأحكام وشروط شركة الطيران المعنية.
        <br />
        تحتفظ شركات الطيران بالحق في إعادة جدولة مواعيد الرحلات أو مسارها أو تغييرها أو إلغائها بشكل
        مستقل وبدون إخطار مسبق لميكمايتريب. ولن تكون لميكمايتريب أي سيطرة على تجهيزات وإمدادات شركات
        الطيران، بناء على ذلك ولا تتحمل ميكمايتريب مسؤولية أي خسارة مباشرة أو غير مباشرة يتكبدها
        المستخدم بسبب هذا التغيير أو إلغاء الرحلات.
        <br />
        قد تحمل التذاكر المختلفة على نفس شركة الطيران قيودا أو تشمل على خدمات وأسعار مختلفة.
        <br />
        يكون حد الأمتعة المسموح به على أسعار معينة وفقا للشروط التي تقررها شركة الطيران، ولا يكون
        لدى ميكمايتريب أي دور في هذا الأمر. وبعض الأسعار المعروضة على صفحة الحجز هي "أسعار حقائب
        اليد" التي لا تمنح المستخدم الحق في إضافة تسجيل الأمتعة مجانا، وبالتالي سيطلب من المستخدم
        الدفع بشكل منفصل لتسجيل الأمتعة. وقد تختلف الأسعار لإضافة تسجيل الأمتعة إلى الحجز من شركة
        طيران لأخرى. وينصح المستخدم بالاتصال بشركات الطيران للحصول على تكاليف مفصلة.
        <br />
        <b> مشاركة الرمز</b>
        <br />
        تبرم بعض شركات الطيران اتفاقيات "مشاركة الرمز" مع شركات الطيران الأخرى. وهذا يعني أنه في
        مسارات معينة، لا تقوم شركة الطيران التي تبيع أو تسوّق تذكرة الرحلة بطيرانها إلى تلك الوجهة.
        بدلاً من ذلك، تتعاقد مع شركة طيران أخرى أو تتعاون معها للسفر إلى تلك الوجهة. تم إدراج شركة
        الطيران الشريكة على أنها "مُدارة بواسطة" في الحجز.
        <br />
        إذا كانت رحلتك عبارة عن مشاركة الرمز، فسيتم الكشف عنها لك عند عملية الحجز وقبل الدفع.
        <br />
        ستكشف ميكمايتريب عن أي ترتيبات مشاركة الرمز من هذا القبيل للمستخدم، عندما تقوم شركة الطيران
        التي تصدر التذاكر بالكشف عنها لـميكمايتريب أولا.
        <br />
        <b>التسعير</b>
        <br />
        يشتمل السعر الإجمالي المعروض على الموقع في صفحة الدفع على السعر الأساسي والضرائب الحكومية
        المطبقة ورسوم الخدمة عادة (قد تختلف التسميات). ويتعين على المستخدمين دفع المبلغ بالكامل قبل
        تأكيد حجزهم أو حجوزاتهم. في حالة عدم دفع المستخدم المبلغ بالكامل، وتحتفظ ميكمايتريب بحقها في
        إلغاء الحجز. ويوافق المستخدم على دفع جميع الضرائب القانونية والرسوم الإضافية كما هي معمولة
        بها في تاريخ السفر.
        <br />
        للاستفادة من أسعار الرضع، يجب أن يكون عمر الطفل أقل من 24 شهراً طوال مسار الرحلة بأكمله بما
        فيها رحلات الذهاب والعودة. إذا بلغ من عمر الرضيع 24 شهرًا أو أكثر في رحلة العودة، فسيُطلب من
        المستخدم إجراء حجز منفصل باستخدام سعر الطفل. يجب أن يكون أي رضع أو أطفال مصحوبين بشخص بالغ
        وفقًا لشروط شركات الطيران.
        <br />
        <b>وثائق السفر</b>
        <br />
        تقع على عاتق المستخدم وحده مسؤولية التأكد من حيازته وثائق السفر السارية مثل بطاقة الهوية
        وجواز السفر والتأشيرة (بما في ذلك تأشيرة الترانزيت) وما إلى ذلك للقيام بالسفر. يوافق
        المستخدم على أنه في حالة عدم القدرة على السفر بسبب عدم حمله وثائق سفر صالحة، فإن ميكمايتريب
        لن تكون مسؤولة بأي حال من الأحوال.
        <br />
        يتفهم المستخدم أن المعلومات المقدمة (إن وجدت) من ميكمايتريب فيما يتعلق بوثائق السفر هي
        معلومات إرشادية بطبيعتها ولا يمكن اعتبارها قاطعة ونهائية. ويجب على المستخدم أيضا التأكد من
        التحقق من متطلبات السفر مع شركات الطيران المعنية وفي السلطات القضائية المعنية التي قد يمر
        بها المستخدم أو ينوي الزيارة.
        <br />
        <b>شروط إجراءات السفر</b>
        <br />
        يجب على المستخدم التحقق من شركات الطيران مباشرة فيما يتعلق بمواعيد تسجيل الوصول. عادة، يبدأ
        تسجيل الوصول قبل ساعتين من موعد المغادرة للرحلات الداخلية، و 3 ساعات قبل المغادرة للرحلات
        الدولية.
        <br />
        يجب على المستخدم حمل بطاقة هوية سارية المفعول وجواز السفر وإثباتات العمر التي قد تكون مطلوبة
        لإثبات هوية وجنسية وعمر الركاب المسافرين على تذكرة، بما في ذلك الأطفال والرضع.
        <br />
        <b>استخدام قطاعات الطيران</b>
        <br />
        يتم إلغاء رقم التذكرة تلقائيًا (بيانات أسماء المسافرين) المتعلق بهذا الحجز من قبل شركة
        الطيران في حالة عدم شروع المستخدم في رحلة تالية. وفي مثل هذه الحالة، ليس لميكمايتريب سيطرة
        على العملية المذكورة ولن تكون ملزمة بتوفير حجوزات بديلة للمستخدم. ويجب أن تكون عقوبة الإلغاء
        في مثل هذه الحالة وفقًا لقواعد شركة الطيران المعمول بها.
        <br />
        <b>تغييرات في الحجز الحالي</b>
        <br />
        تخضع التغييرات التي يتم إجراؤها في الحجز الحالي لرسوم معينة تفرضها شركة الطيران المعنية،
        فضلا عن رسوم الخدمة التي تفرضها ميكمايتريب
        <br />
        يجب على المستخدم دفع الرسوم المطبقة في حالة إدارج أي تغيير أو تعديل في الحجز الحالي. ومع
        ذلك، بناءً على سياسة شركة الطيران وفئة السعر، قد تختلف رسوم التغييرات أو التعديلات في
        الحجوزات الحالية.
        <h3>فنادق</h3>
        <p>
          لا تتوفر خدمات الفنادق للحجز على الموقع الإلكتروني، وبالتالي، لا تنطبق شروط خدمة الفنادق
          المذكورة أدناه. ومع ذلك، سيتم تطبيق نفس الشروط المعينة وتكون ملزمًا للمستخدمين اعتبارًا من
          تاريخ قرار ميكمايتريب على أن يشغل خدمات الفنادق على الموقع الإلكتروني.
          <br />
          <b>دور ميكمايتريب وحدود مسؤوليته</b>
          <br />
          تعمل ميكمايتريب كمسهل وتوفر منصة عبر الإنترنت للمستخدم لاختيار وحجز فندق معين. تشمل
          الفنادق في هذا السياق على جميع فئات أماكن الإقامة مثل الفنادق والإقامات المنزلية وإقامات
          المبيت والإفطار ومنازل المزارع وأماكن إقامة بديلة أخرى.
          <br />
          جميع المعلومات المتعلقة بالفندق بما في ذلك فئة الفندق والصور ونوع الغرفة ووسائل الراحة
          والمرافق المتوفرة في الفندق هي وفقًا للمعلومات التي قدمها الفندق إلى ميكمايتريب. وهذه
          المعلومات مقدمة لغرض المراجعة فقط. يتم إبلاغ المستخدم أي تناقض قد يكون موجودًا بين صور
          الموقع والإعدادات الفعلية للفندق، بالفندق مباشرةً، ويجب حله بين المستخدم والفندق ولن تتحمل
          ميكمايتريب أي مسؤولية في إجراءات حل المشكلة كما أنه لا تكون مسؤولية عن مثل هذه التناقضات.
          <br />
          <b>معلومات هامة من الفندق وشروطه</b>
          <br />
          قسيمة حجز الفندق التي تصدرها ميكمايتريب للمستخدم تعتمد على المعلومات المقدمة أو المستجدة
          من قبل الفندق فيما يتعلق بتوافر المخزون فقط. ولا تتحمل ميكمايتريب في أي حال من الأحوال
          مسؤولية عن فشل الفندق في استيعاب المستخدم بحجز مؤكد أو مستوى الخدمة أو أي قصور في الخدمات
          أو أي مشكلات أخرى متعلقة بالخدمة في الفندق. وستقتصر مسؤولية ميكمايتريب في حالة رفض تسجيل
          الوصول من قبل فندق لأي سبب من الأسباب - بما في ذلك الحجز الزائد أو الفشل في النظام أو
          الأخطاء التقنية أو عدم توفر الغرف وما إلى ذلك - على توفير إقامة بديلة مماثلة وفقًا لسعة
          ميكمايتريب (حسب التوافر في ذلك الوقت)، أو على استرداد مبلغ الحجز (بالقدر المدفوع)
          للمستخدم. يجب على المستخدم حل أي مشكلات أخرى متعلقة بالخدمة مباشرةً مع الفندق.
          <br />
          تحتفظ الفنادق بالحق في التسجيل، وليس لدى ميكمايتريب أي حق على الإطلاق في القبول أو الرفض
          من قبل الفندق. ولا يُسمح غير المتزوجين أو الأزواج التي لا علاقة بينهم بتسجيل الوصول من قبل
          بعض الفنادق وفقًا لسياساتها وكذلك يتم رفض الإقامة للضيوف الذين يتنكرون كزوجين إذا لم يتم
          تقديم إثبات هوية مناسبة في وقت تسجيل الوصول. وقد لا يسمح بعض الفنادق أيضًا للسكان المحليين
          بتسجيل الوصول كضيوف. ولن تتحمل ميكمايتريب مسؤولة أي تسجيل وصول يرفضه الفندق للأسباب
          المذكورة أعلاه أو لأي سبب آخر غير خاضع لسيطرة ميكمايتريب. ولن يتم تطبيق أي استرداد في حالة
          رفض الفندق تسجيل الوصول في مثل هذه الظروف.
          <br />
          <b>مسؤوليات المستخدم</b>
          <br />
          سيكون المستخدم مسؤولاً عن إصلاح أي ضرر (أضرار) ناشئة عن أي فعل من جانبه أو من جانبها / أو
          من الضيوف المرافقين لهم (متعمدًا كان أو غافلا) لممتلكات الفندق بأي طريقة كانت. سيتم تحديد
          مدى ومقدار الضرر الناشئ من قبل الفندق المعني، ولن تتدخل ميكمايتريب بأي شكل من الأشكال في
          نفس الأمر.
          <br />
          يجب ألا يقل عمر الضيف الأساسي عن 18 عامًا حتى يتمكن من تسجيل الوصول إلى الفندق.
          <br />
          يجب أن يكون لدى المستخدم إثبات هوية صالح وإثبات العنوان وقت تسجيل الوصول. وتحتفظ الفندق
          بالحق في رفض تسجيل الوصول إلى المستخدم إذا لم يتم تقديم إثبات هوية ساري المفعول في وقت
          تسجيل الوصول.
          <br />
          سيكون وقت تسجيل الوصول وتسجيل المغادرة وأي تغييرات في تلك الأوقات وفقًا لسياسة الفندق
          وشروطه. يخضع طلب تسجيل الوصول المبكر أو تسجيل المغادرة المتأخر للتوفر وقد يفرض الفندق
          رسومًا إضافية مقابل تقديم هذه الخدمات.
          <br />
          <b>رسوم إضافية من قبل الفندق</b>
          <br />
          مبلغ الحجز الذي يدفعه المستخدم هو للإقامة في الفندق فقط. قد يشمل بعض الحجوزات وجبة الإفطار
          أو جميع الوجبات كما تم تأكيدها في وقت الحجز. ويجب على المستخدم أن يدفع تكاليف الخدمات
          الأخرى التي يستخدمها المستخدم في الفندق، بما فيها غسيل الملابس وخدمة الغرف والإنترنت
          والهاتف والأطعمة الإضافية والمشروبات والمشروبات الكوحول وما إلى ذلك، في الفندق مباشرة.
          <br />
          قد تفرض الفنادق رسومًا إلزامية على الوجبة في فترات الأعياد مثل عيد الميلاد أو ليلة رأس
          السنة أو غيرها من المهرجانات وفقًا لما يقرره الفندق. يجب تسديد جميع الرسوم الإضافية (بما
          في ذلك الرسوم الإضافية الإلزامية للوجبات) في الفندق مباشرةً. ولن يكون لـميكمايتريب أي
          سيطرة على التخلي عنها.
          <br />
          <b>الدفع للحجوزات والرسوم الإضافية الأخرى</b>
          <br />
          يمكن أن يكون حجز الفندق تحت خيار "الدفع المسبق" أو "الدفع في الفندق" وفقًا للخيارات التي
          يوفرها فندق على الموقع الخاص بـميكمايتريب. يتم دفع المستخدم مبلغ الحجز الإجمالي في وقت
          الحجز نفسه عندما يختار طريقة "الدفع المسبق". ويشمل مبلغ الحجز الإجمالي على سعر الحجز في
          الفندق والضرائب ورسوم الخدمة التي قد يتم فرضها نيابة عن المزود الحقيقي للخدمة وعلى رسوم
          الخدمة التي تفرضها ميكمايتريب.
          <br />
          وفقًا لتقدير الفندق أو ميكمايتريب المطلق على أساس كل حالة على حدة، يجوز أيضًا تزويد
          المستخدم بخيار إجراء دفعة جزئية إلى ميكمايتريب وقت تأكيد الحجز، يجب دفع مبلغ الحجز المتبقي
          وفقًا لشروط الحجوزات.
          <br />
          يجب على المستخدم تزويد بتفاصيل بطاقة الائتمان أو الخصم الصحيحة إلى ميكمايتريب للأغراض
          الأمنية. وقد تقوم ميكمايتريب بإلغاء الحجز وفقًا لتقديرها الخاص في حالة العثور على تفاصيل
          البنك أو بطاقة الائتمان المتقدمة من قبل المستخدم غير صحيحة.
          <br />
          يمكن دفع المبلغ إما بالدرهم أو بأي عملة أجنبية أخرى كما هو محدد في وقت الحجز. يفرض بعض
          البنوك والشركات المصدرة للبطاقات رسومًا للمعاملة على أصحاب حساباتهم عندما يكون مُصدر
          البطاقة والموقع التجاري (كما هو محدد من قبل العلامة التجارية للبطاقة، مثل فيزا وماستركارد
          وأمريكان إكسبريس) في بلدان مختلفة. إذا كان لدى المستخدم أي أسئلة حول الرسوم أو أي سعر مطبق
          للمعاملة، فيجوز له الاتصال بالبنك أو الشركة المصدرة للبطاقة التي تم الدفع من خلالها.
          <br />
          قد يطلب بعض مزودي أماكن الإقامة من المستخدم أو من الأشخاص الآخرين الذين تم إجراء الحجز
          نيابة عنهم، تقديم بطاقة ائتمان أو إيداع نقدي عند تسجيل الوصول لتغطية النفقات الإضافية التي
          قد يتم تكبدها أثناء إقامتهم. لا علاقة لهذا الإيداع بأي دفعة تتلقاها ميكمايتريب وبناءً على
          طلب الفندق فقط.
          <br />
          في حالة دفع المستخدم عن طريفة "الدفع في الفندق" يتقاضى الفندق المعني الدفع الكامل للحجز
          وقت تسجيل الوصول. في حالة الحجوزات الدولية، يتم فرض الدفع باستخدام العملة المحلية أو في
          العملات الأجنبية الأخرى كما يقرره الفندق. وللأغراض الأمنية يجب على المستخدم تقديم تفاصيل
          بطاقة الإئتمان أو الخصم الصحيحة لميكمايتريب وقد تقوم ميكمايتريب بإلغاء الحجز وفقًا
          لتقديرها الخاص في حالة العثور على تفاصيل البنك أو بطاقة الائتمان المتقدمة من قبل المستخدم
          غير صحيحة.
          <br />
        </p>
      </S.PrivacyContent>
    </>
  );
};

export default PrivacyPolicyGccArabicContent;
